module.exports = __webpack_public_path__ + "media/images/restaurant/areas/tokyo-44b795a73540fee0003d2364bfc1703f.png";